import { JumpNav, Tab, useJumpNavConfig } from '@uplift/ui-v2';
import { SelectedProviderTabEnum } from '../types';

import { makeStyles } from 'tss-react/mui';

export type SelectedProviderJumpNavProps = {
  forceMobile?: boolean;
};

const tabTitleHash: Record<SelectedProviderTabEnum, string> = {
  [SelectedProviderTabEnum.expertise]: 'Expertise',
  [SelectedProviderTabEnum.about]: 'About',
  [SelectedProviderTabEnum.moreInfo]: 'More Info',
};

const sectionIds = [
  SelectedProviderTabEnum.expertise,
  SelectedProviderTabEnum.about,
  SelectedProviderTabEnum.moreInfo
];

export const SelectedProviderJumpNav: React.VFC<SelectedProviderJumpNavProps> = (props) => {
  const { classes } = useSelectedProviderJumpNavStyles(props, {
    props: props
  });
  const { navValue } = useJumpNavConfig({ initialNavValue: sectionIds[0], sectionIds: sectionIds });

  return (
    <JumpNav
      value={navValue}
      indicatorColor="secondary"
      textColor="secondary"
      variant="scrollable"
    >
      {sectionIds.map((tabId) => {
        const label = tabTitleHash[tabId];

        return (
          <Tab
            jump
            label={label}
            value={tabId}
            key={tabId}
            className={classes.tab}
            headerOffset={56}
          />
        );
      })}
    </JumpNav>
  );
};

const useSelectedProviderJumpNavStyles = makeStyles<{ forceMobile?: boolean }>({ name: 'SelectedProviderJumpNav' })((theme, { forceMobile }) => ({
  tab: ({
    borderBottom: 'none',
    flex: 1,
    minWidth: 'unset',
    fontSize: '13px',

    ...(!forceMobile && ({
      [theme.breakpoints.up('sm')]: {
        flex: 'unset',
        minWidth: '160px',
        fontSize: '15px'
      }
    }))
  }),
}));
